import React  from 'react';
import moment from 'moment';
import {  UserAccountTypeEnum } from '../../../../../Enums';

const repeated = (list, filed) =>
  list &&
  list.map((item, index) =>
    !item[filed] ? (
      <span key={index}>
        <span> </span>
      </span>
    ) : (
      <span key={index}>
        {" "}
        {item[filed]} {list.length - 1 != index && <span> , </span>}
      </span>
    )
  );

export const VendorsMapper = (item, vendor) => {
  const getAccountType = (type) => {
    if (type === 'Normal') return UserAccountTypeEnum.normal.value;
    if (type === 'VIP') return UserAccountTypeEnum.platinum.value;
    if (type === 'VVIP') return UserAccountTypeEnum.gold.value;
    return null;
  };
  if (vendor) {
    return {
      ...vendor,
      contactId: item.contactId,
      name:
        (vendor && vendor.vendor_name && vendor.vendor_name.name) ||
        "" ||
        "N/A",
      id: item.vendorId,
      createdBy: item.createdBy,
      updatedBy: item.updatedBy,
      // imagePath:
      //   (vendor &&
      //     vendor &&
      //     vendor.contact_photo &&
      //     vendor.contact_photo["Image Upload"] &&
      //     vendor.contact_photo["Image Upload"][0] &&
      //     vendor.contact_photo["Image Upload"][0].uuid) ||
      //   "",
      imagePath:
        (vendor &&
          vendor &&
          vendor.vendor_logo &&
          vendor.vendor_logo["Company Logo"] &&
          vendor.vendor_logo["Company Logo"][0] &&
          vendor.vendor_logo["Company Logo"][0].uuid) ||
        "",
      updateDate: item && item.updateOn,
      vendorClass:
        vendor && vendor.vendor_class && vendor.vendor_class?.lookupItemName,
      vendorEmail: (vendor && vendor.vendor_email && vendor?.vendor_email?.email) || '',
      accountType:
        vendor &&
        vendor.vendor_class &&
        vendor.vendor_class?.lookupItemName &&
        getAccountType(vendor.vendor_class.lookupItemName),
      vendor_category:
        (vendor &&
          vendor.vendor_category &&
          Array.isArray(vendor.vendor_category) &&
          vendor.vendor_category
            .map((item) => item.lookupItemName)
            .join(", ")) ||
        "",
      contact_remarks:
        (vendor && vendor?.contact_remarks && vendor.contact_remarks) || "",
      progress:
        vendor &&
        vendor?.data_completed &&
        typeof vendor &&
        vendor.data_completed === "string" &&
        vendor.data_completed.includes("%")
          ? vendor.data_completed.substr(0, vendor.data_completed.length - 1)
          : vendor && vendor.data_completed,
      progressWithPercentage:
        vendor &&
        vendor?.data_completed &&
        typeof vendor &&
        vendor.data_completed &&
        vendor.data_completed !== "string"
          ? `${vendor && vendor.data_completed && vendor.data_completed}%`
          : vendor && vendor.data_completed,
      createdOn:
        (item &&
          item?.createdOn &&
          moment(item.createdOn).isValid() &&
          item.createdOn) ||
        null,
      updateOn:
        (item.updateOn && moment(item.updateOn).isValid() && item.updateOn) ||
        null,
      agreementStatusId: (item && item.agreementStatusId) || "",
      agreementStatusName: (item && item.agreementStatusName) || "",
      contractStartDate: (item && item.contractStartDate) || "",
      contractExpiryDate: (item && item.contractExpiryDate) || "",
      lastUpdatedDate: (item && item.lastUpdatedDate) || "",
      createdBy: (item && item.createdBy) || "",
      createdDate: (item && item.createdDate) || "",
      numberOfOffers: (item && item.numberOfOffers) || "",
      lastActivityName: (item && item.lastActivityName) || "",
      lastActivityDate: (item && item.lastActivityDate) || "",
      lastActivityCreatedBy: (item && item.lastActivityCreatedBy) || "",
      details: [
        {
          title: "name",
          value:
            (vendor && vendor.vendor_name && vendor.vendor_name.name) || "N/A",
        },
        {
          title: "Contact Number",
          value:
            (vendor &&
              vendor?.landline_number &&
              vendor.landline_number.phone) ||
            "N/A",
        },
        {
          title: "email",
          value: (vendor && vendor?.vendor_email && vendor.vendor_email?.email) || "N/A",
        },
        {
          title: "location",
          value:
            ((vendor &&
              vendor.country &&
              vendor.country?.lookupItemName &&
              `${vendor.country.lookupItemName}`) ||
              "") +
              ((vendor &&
                vendor.city &&
                vendor.city?.lookupItemName &&
                `, ${vendor.city?.lookupItemName}`) ||
                "") +
              ((vendor &&
                vendor.street &&
                vendor.street?.value &&
                `, ${vendor.street?.value} `) ||
                "") || "N/A",
        },
        {
          title: "vendor-category",
          value:
            (vendor &&
              vendor.vendor_category &&
              Array.isArray(vendor.vendor_category) &&
              vendor.vendor_category.length > 0 &&
              vendor.vendor_category.map((el) => el.lookupItemName)) ||
            "N/A",
        },
        {
          title: "agreement-status",
          value: (item && item?.agreementStatusName) || "N/A",
        },

        {
          ContactAllDetails: [
            {
              title: "vendor_class",
              value:
                (vendor &&
                  vendor.vendor_class &&
                  vendor.vendor_class?.lookupItemName) ||
                "",
            },
            {
              title: "job_title",
              value:
                (vendor && vendor.job_title && vendor.title?.lookupItemName) ||
                "N/A",
            },
            {
              title: "createdOn",
              value: (item && item?.createdOn) || "",
            },
            {
              title: "building_name",
              value:
                (vendor &&
                  vendor?.building_name &&
                  vendor?.building_name?.value) ||
                "N/A",
            },
            {
              title: "building_no",
              value:
                (vendor && vendor.building_no && vendor.building_no?.value) ||
                "",
            },
            {
              title: "near_by",
              value: (vendor && vendor.near_by && vendor.near_by?.value) || "",
            },
            {
              title: "postalzip_code",
              value:
                (vendor &&
                  vendor.postalzip_code &&
                  vendor.postalzip_code?.value) ||
                "",
            },
            {
              title: "pobox",
              value: (vendor && vendor.pobox && vendor.pobox) || "",
            },
            {
              title: "address_line1",
              value:
                (vendor &&
                  vendor.address_line1 &&
                  vendor.address_line1?.value) ||
                "",
            },
            {
              title: "country",
              value:
                (vendor && vendor.country && vendor.country?.lookupItemName) ||
                "",
            },
            {
              title: "city",
              value:
                (vendor && vendor.city && vendor.city?.lookupItemName) || "",
            },

            {
              title: "district",
              value:
                (vendor &&
                  vendor.district &&
                  vendor.district?.lookupItemName) ||
                "",
            },
            {
              title: "community",
              value:
                (vendor &&
                  vendor.community &&
                  vendor.community?.lookupItemName) ||
                "",
            },

            {
              title: "data_completed",
              value: (vendor && vendor?.data_completed) || "",
            },
            {
              title: "other_contact_mobile_no",
              value:
                (vendor &&
                  vendor?.other_contact_mobile_no &&
                  vendor.other_contact_mobile_no?.phone) ||
                "",
            },

            {
              title: "facebook_link",
              value:
                (vendor && vendor.facebook_link && vendor.facebook_link.link) ||
                "",
            },
            {
              title: "postalzip_code",
              value:
                (vendor &&
                  vendor.postalzip_code &&
                  vendor.postalzip_code.value) ||
                "",
            },
            {
              title: "near_by",
              value: (vendor && vendor.near_by && vendor.near_by.value) || "",
            },
            {
              title: "address_line2",
              value:
                (vendor && vendor.address_line2 && vendor.address_line2) || "",
            },
            {
              title: "pobox",
              value: (vendor && vendor.pobox) || "",
            },
            {
              title: "street",
              value: (vendor && vendor.street && vendor.street.value) || "",
            },
            {
              title: "building_name",
              value:
                (vendor &&
                  vendor.building_name &&
                  vendor.building_name.value) ||
                "",
            },
            {
              title: "office_no",
              value:
                (vendor && vendor.office_no && vendor.office_no.value) || "",
            },
            {
              title: "floor_no",
              value: (vendor && vendor.floor_no && vendor.floor_no.value) || "",
            },
          ],
        },
      ],
      allDetails: {
        "General Information": [
          {
            title: "vendor_name",
            value: (vendor && vendor?.vendor_name?.name) || "N/A",
          },
          {
            title: "Contact Number *",
            value:
              (vendor &&
                vendor?.landline_number &&
                vendor.landline_number.phone) ||
              "N/A",
          },
          ,
          {
            title: "email_address",
            value:
              (vendor &&
                vendor?.vendor_email &&
                vendor?.vendor_email?.email) ||
              "N/A",
          },
          {
            title: "vendor_class",
            value:
              (vendor &&
                vendor.vendor_class &&
                vendor.vendor_class?.lookupItemName) ||
              "N/A",
          },
          {
            title: "website_url",
            value: (vendor && vendor.website_url) || "N/A",
          },
          {
            title: "country",
            value:
              (vendor && vendor.country && vendor.country?.lookupItemName) ||
              "N/A",
          },
          {
            title: "city",
            value:
              (vendor && vendor.city && vendor.city?.lookupItemName) || "N/A",
          },
        ],
        "Social Media": [
          {
            title: "facebook_link",
            value:
              (vendor && vendor.facebook_link && vendor.facebook_link.link) ||
              "N/A",
          },
          {
            title: "twitter_link",
            value:
              (vendor && vendor.twitter_link && vendor.twitter_link.link) ||
              "N/A",
          },
          {
            title: "instagram_link",
            value:
              (vendor && vendor.instagram_link && vendor.instagram_link.link) ||
              "N/A",
          },
          {
            title: "linkedin_link",
            value:
              (vendor && vendor.linkedin_link && vendor.linkedin_link.link) ||
              "N/A",
          },
        ],
        "Location Details": [
          {
            title: "country",
            value:
              (vendor && vendor.country && vendor.country.lookupItemName) ||
              "N/A",
          },
          {
            title: "city",
            value:
              (vendor && vendor.city && vendor.city.lookupItemName) || "N/A",
          },
          {
            title: "district",
            value:
              (vendor && vendor.district && vendor.district.lookupItemName) ||
              "N/A",
          },
          {
            title: "community",
            value:
              (vendor && vendor.community && vendor.community.lookupItemName) ||
              "N/A",
          },
          {
            title: "street",
            value: (vendor && vendor.street && vendor.street.value) || "N/A",
          },
          {
            title: "building_name",
            value:
              (vendor && vendor.building_name && vendor.building_name.value) ||
              "N/A",
          },
          {
            title: "map",
            value:
              (vendor &&
                vendor.map &&
                `Longitude: ${vendor && vendor.map.longitude}, Latitude: ${
                  vendor.map.latitude
                }`) ||
              "N/A",
          },
          {
            title: "address_line_1",
            value:
              (vendor &&
                vendor.address_line_1 &&
                vendor.address_line_1.value) ||
              "N/A",
          },
          {
            title: "near_by",
            value: (vendor && vendor.near_by && vendor.near_by.value) || "N/A",
          },
        ],
      },
    };
  }
};
